<template>
    <v-container>
        <h1 class="titulo mb-3">Config. De Grupos</h1>
        <v-card class="v-card card-container">
            <v-card-text>
                <div>
                    <div id="tabs" class="container">
                        <div class="tabs">
                            <div><a @click="activetab=FINANCING_GROUP" :class="{ active: activetab === FINANCING_GROUP }">Configuração Grupos Pontuais</a></div>
                            <div><a @click="activetab=FOR_NOW_GROUP" :class="{ active: activetab === FOR_NOW_GROUP }">Configuração Grupos Pra Já</a></div>
                        </div>
                        <div class="content">
                            <div v-if="activetab === FINANCING_GROUP" class="tabcontent">
                                <GruposFinanciamento ref="financingGroups" />
                            </div>
                            <div v-if="activetab === FOR_NOW_GROUP" class="tabcontent">
                                <GruposPraJa />
                            </div>
                        </div>
                    </div>
                </div>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
  import GruposFinanciamento from './GruposFinanciamento.vue'
  import GruposPraJa from './GruposPraJa.vue'

  export default {
    name: 'ConfigGrupos',
    components: { GruposFinanciamento, GruposPraJa },
    data: () => ({
      activetab: 'financing_group',
      detailedQueriesData: ''
    }),
    computed: {
      FINANCING_GROUP: () => 'financing_group',
      FOR_NOW_GROUP: () => 'for_now_group'
    }
  }
</script>

<style scoped lang="scss">
.title-date {
    color: var(--primary);
    font-weight: 800;
}
.listagem th {
    min-width: 90px;
}
.listagem th:nth-of-type(2) {
    min-width: auto;
}
@import url('../../../assets/css/tabs.css');

</style>
